var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-popup",class:[
    {
      'base-popup--disabled': _vm.disabled,
      'content--top': _vm.isTop
    },
    _vm.colorClass
  ]},[_vm._t("default"),_c('div',{staticClass:"base-popup__content",class:_vm.contentClasses},[_vm._t("content",function(){return [_vm._v(_vm._s(_vm.label))]})],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }